import { useEffect, useRef } from 'react';
import { usePhoneTrackerLayout } from './usePhoneTrackerLayout';

export function useTrackerPhoneDrawer(open: boolean, close: () => void) {
  const phone = usePhoneTrackerLayout();
  const pane = useRef<HTMLElement>(null);
  const closeRef = useRef(close);
  closeRef.current = close;
  useEffect(() => {
    if (!phone || !open || !pane.current) return;
    const previous = document.activeElement as HTMLElement | null;
    const root = pane.current;
    const controls = () => Array.from(root.querySelectorAll<HTMLElement>('button:not(:disabled),a[href],input,select,[tabindex="0"]')).filter(element => element.getClientRects().length > 0);
    controls()[0]?.focus();
    const keydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { event.preventDefault(); closeRef.current(); }
      if (event.key !== 'Tab') return;
      const targets = controls();
      const first = targets[0];
      const last = targets.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    };
    root.addEventListener('keydown', keydown);
    return () => { root.removeEventListener('keydown', keydown); previous?.focus(); };
  }, [phone, open]);
  return { pane, modal: phone && open };
}
